const normalizeUnicodeText = (value) => (value !== null && value !== void 0 ? value : '').normalize('NFC');
/** Normalizes navigation labels without mutating CMS data or changing links. */
const normalizeNavigationTitles = (node) => {
    var _a;
    const title = normalizeUnicodeText(node.title);
    const headlineTitle = node.headlineTitle === undefined
        ? undefined
        : normalizeUnicodeText(node.headlineTitle);
    const items = (_a = node.items) === null || _a === void 0 ? void 0 : _a.map(item => normalizeNavigationTitles(item));
    const itemsChanged = items === null || items === void 0 ? void 0 : items.some((item, index) => { var _a; return item !== ((_a = node.items) === null || _a === void 0 ? void 0 : _a[index]); });
    if (title === node.title &&
        headlineTitle === node.headlineTitle &&
        !itemsChanged) {
        return node;
    }
    return Object.assign(Object.assign(Object.assign(Object.assign({}, node), { title }), (node.headlineTitle === undefined ? {} : { headlineTitle })), (itemsChanged ? { items } : {}));
};

export { normalizeNavigationTitles, normalizeUnicodeText };
